<div *ngIf="component === 'card-primary'" class="card-wrapper {{size}}-card" [ngClass]="(flavor === 'edged') ? 'edged' : ''">
  <section class="img-section">
    <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"
    [theme]="{
      width: '100%',
      height: '100%'
    }"
    ></ngx-skeleton-loader>
  </section>
  <section class="card-content" >
    <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
      width: '100%',
      height: '100%'
    }"></ngx-skeleton-loader>
  </section>
  <section class="btn-section">
    <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
      width: '100%',
      height: '100%'
    }"></ngx-skeleton-loader>
  </section>
</div>


<div *ngIf="component === 'offer-detail'"
  class="container-fluid lg-screen"
>
  <div class="back">
    <!-- <img src="../../../assets/svg/backward-arrow.svg" (click)="back()" /> -->
    <!-- <div class="col-1"  (click)="back()">Back</div> -->
  </div>
  <div class="row content-panel">
    <div class="col-md-3 col-lg-3 left-pane">
      <div class="title-card">
        <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
          width: '100%',
          height: '100%'
        }"></ngx-skeleton-loader>
      </div>
      <div class="label">
        <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
          width: '100%',
          height: '100%'
        }"></ngx-skeleton-loader>
      </div>
      <div
        class="description"
      >
      <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
        width: '100%',
        height: '100%'
      }"></ngx-skeleton-loader></div>
      <div class="btn-section">
        <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
          width: '100%',
          height: '100%'
        }"></ngx-skeleton-loader>
      </div>
    </div>
    <div class="col-md-7 col-lg-7 right-pane">
      <div
      class="multi-offer-selection"
    >
      <!-- <ng-container> -->
        <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
          width: '100%',
          height: '100%'
        }"></ngx-skeleton-loader>
      <!-- </ng-container> -->
    </div>
      <div class="card-panel">
        <div class="headline">
            <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
              width: '100%',
              height: '100%'
            }"></ngx-skeleton-loader>
        </div>
        <div class="offer-description">
          <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
            width: '100%',
            height: '100%'
          }"></ngx-skeleton-loader>
        </div>
        <div class="validity">    <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
          width: '100%',
          height: '100%'
        }"></ngx-skeleton-loader>


        </div>
        <div class="accor">
          <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
            width: '100%',
            height: '100%'
          }"></ngx-skeleton-loader>
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf="component === 'offer-detail-mobile'" class="row height-check">

<section class="offer-banner col-md-4 col-lg-4 col-sm-12 col-12">
  <div class="banner">
    <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
      width: '100%',
      height: '100%'
    }"></ngx-skeleton-loader>
  </div>
  <div
    class="multi-offer-selection"
  >
  <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
    width: '100%',
    height: '100%'
  }"></ngx-skeleton-loader>
  </div>
  <div class="details">
    <div class="merchant-name">
      <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
        width: '100%',
        height: '100%'
      }"></ngx-skeleton-loader>
    </div>
    <div class="offer-short-heading">
      <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
        width: '100%',
        height: '100%'
      }"></ngx-skeleton-loader>
    </div>
    <div
      class="offer-long-description"
    >
    <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
      width: '100%',
      height: '100%'
    }"></ngx-skeleton-loader>
    </div>
    <div class="expiry">
      <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
        width: '100%',
        height: '100%'
      }"></ngx-skeleton-loader>
    </div>
  </div>
</section>
<section class="offer-terms col-md-8 col-lg-8 col-sm-12 col-12">
  <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
    width: '100%',
    height: '100%'
  }"></ngx-skeleton-loader>
</section>

<div class="btn-container-placeholder">
  <!-- <app-poshvine-button [text]="'Claim offer'" (click)="claimOffer()"></app-poshvine-button> -->
</div>
<div class="btn-container">
  <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
    width: '100%',
    height: '100%'
  }"></ngx-skeleton-loader>
</div>
</div>
<ng-container *ngIf="component === 'redemption-history'">
  <section class="redemption-parent">
    <section class="new-page">
      <div class="c-000 fnt-20 mar-top-45 mar-bot-20 heading">  <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
        width: '100%',
        height: '100%'
      }"></ngx-skeleton-loader></div>
      <div class="g-contain pad-20 bg-fff pad-bot-1 mar-bot-50">
        <ng-container *ngFor="let order of [1,2,3,4,5,6]; let i = index">

          <div class="g-in pad-25 mar-bot-25 pad-bot-5">
            <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
              width: '100%',
              height: '100%'
            }"></ngx-skeleton-loader>
          </div>
        </ng-container>
      </div>
    </section>
  </section>
</ng-container>

<div *ngIf="component === 'category-scroller'"
  class="container-fluid"
>
  <div class="row">
    <div class="col-md-10 col-lg-11 col-sm-9 col-8 button-label">
      <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
        width: '89%',
        height: '100%'
      }"></ngx-skeleton-loader>
    </div>
    <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
      width: '89%',
      height: '100%'
    }"></ngx-skeleton-loader>
  </div>
  <div class="offers-row" *ngIf="true">
    <ng-container>
      <ng-container *ngFor="let cardData of [1,2,3]">
        <div class="card-wrapper medium-card">
          <section class="img-section">
            <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"
            [theme]="{
              width: '100%',
              height: '100%'
            }"
            ></ngx-skeleton-loader>
          </section>
          <section class="card-content" >
            <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
              width: '100%',
              height: '100%'
            }"></ngx-skeleton-loader>
          </section>
          <section class="btn-section">
            <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
              width: '100%',
              height: '100%'
            }"></ngx-skeleton-loader>
          </section>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="component === 'plain-square'">
  <ngx-skeleton-loader [animation]="'progress'" [appearance]="'line'"    [theme]="{
    width: '100%',
    height: '100%'
  }"></ngx-skeleton-loader>
</ng-container>

<ng-container *ngIf="component === 'plain-circle'">
  <ngx-skeleton-loader [animation]="'progress'" [appearance]="'circle'"    [theme]="{
    width: '100%',
    height: '100%'
  }"></ngx-skeleton-loader>
</ng-container>

